import { render } from "./GlossaryMenu.vue?vue&type=template&id=1bea17b6&scoped=true&ts=true"
import script from "./GlossaryMenu.vue?vue&type=script&lang=ts"
export * from "./GlossaryMenu.vue?vue&type=script&lang=ts"

import "./GlossaryMenu.vue?vue&type=style&index=0&id=1bea17b6&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bea17b6"]])

export default __exports__